import { getPagePath, trans } from '@spotahome/soyuz/client';
import SoyuzAnalytics from '@spotahome/soyuz-analytics';

import { Button, HeaderContainer } from '@spotahome/ui-library';
import BrandsBanner from '@spotahome/ui-library/src/tenant/components/HeroReferrals/BrandsBanner';
import HeroReferrals from '@spotahome/ui-library/src/tenant/components/HeroReferrals';
import HowReferralsWorkRevamp from '@spotahome/ui-library/src/tenant/components/HowReferralsWorkRevamp';
import CopyCodeIllustration from '@spotahome/ui-library/src/tenant/components/SvgImages/CopyCodeIllustration';
import EnvelopeIllustration from '@spotahome/ui-library/src/tenant/components/SvgImages/EnvelopeIllustration';
import CouponIllustration from '@spotahome/ui-library/src/tenant/components/SvgImages/CouponIllustratrion';

import './ReferAFriendRevamp.scss';

const getHowItWorksSteps = onClickCTA => [
  {
    title: trans('my-referrals.how-it-works.code.title'),
    content: (
      <>
        <span>{trans('refer-a-friend.how-it-works.code.login')}</span>
        <Button
          href={getPagePath('my-referrals')}
          onClick={() => onClickCTA('tenant')}
          color="secondary"
          className="refer-a-friend-revamp__cta-tenant"
          data-test="referee-link-tenant"
        >
          {trans('contact-us.tenant')}
        </Button>
        <Button
          href={getPagePath('externals.landlord-landing-login')}
          onClick={() => onClickCTA('landlord')}
          color="secondary"
          data-test="referee-link-landlord"
        >
          {trans('contact-us.landlord')}
        </Button>
      </>
    ),
    image: <CopyCodeIllustration />
  },
  {
    title: trans('my-referrals.how-it-works.invite.title'),
    content: trans('my-referrals.how-it-works.invite.content'),
    image: <EnvelopeIllustration />
  },
  {
    title: trans('my-referrals.how-it-works.win.title'),
    content: trans('my-referrals.how-it-works.win.content'),
    image: <CouponIllustration />
  }
];

// TODO: rename this by removing the Revamp suffix if 'ReferralsProgramRevamp' experiment is rolled out
const ReferAFriendRevamp = () => {
  const onClickCTA = type => {
    SoyuzAnalytics.sendGA4Event('referral_cta_click', {
      value: type,
      section: 'refer-a-friend'
    });
  };

  return (
    <>
      <HeaderContainer
        login={false}
        showMobileMenu={false}
        links={{
          home: false,
          listYourProperty: false,
          howItWorks: false,
          favorites: false
        }}
      />
      <div className="refer-a-friend-revamp__content">
        <section className="refer-a-friend-revamp__block">
          <HeroReferrals brandsBannerLayout="row" />
        </section>
        <section className="refer-a-friend-revamp__brands-banner">
          <BrandsBanner centered />
        </section>
        <HowReferralsWorkRevamp
          className="refer-a-friend-revamp__block"
          steps={getHowItWorksSteps(onClickCTA)}
          titleSize="large"
        />
      </div>
    </>
  );
};

export default ReferAFriendRevamp;
